import getSdbTheme from "../../sdb.theme.config/index.js";
const sdbTheme = getSdbTheme();
export const typography = {
    fontFamily: sdbTheme.fonts.sourceSansPro.family,
    fontSize: sdbTheme.fonts.sourceSansPro.size,
    fontWeightLight: sdbTheme.fonts.sourceSansPro.weight.light,
    fontWeightRegular: sdbTheme.fonts.sourceSansPro.weight.normal,
    fontWeightMedium: sdbTheme.fonts.sourceSansPro.weight.bold,
};
export default typography;
